import React from 'react';
import { func, string, bool, number } from 'prop-types';
import styled, { css } from 'styled-components';
import { Row } from '../Grid';
import Button from '../Button';

const FooterWrapper = styled(Row)`
    position: ${({ position }) => position};
    bottom: 0;
    width: 100%;
    left: 0;
    padding: 15px;
    border-top: 1px solid #eaeaea;
    background-color: #ffffff;
    ${({ withZindex }) => withZindex && css`
        z-index: 2000;
    `}
`;

const buttonTheme = (theme) => {
    switch (theme) {
        case 'link':
            return { link: true };
        default:
            return { secondary: true };
    }
};

const ConfirmFooterButtons = ({
    onCancel,
    onConfirm,
    cancelLabel,
    confirmLabel,
    cancelDisabled,
    confirmDisabled,
    loading,
    justify,
    position,
    htmlType,
    cancelTheme,
    widthButtons,
    borderRadius
}) => (
    <FooterWrapper
        position={position}
        noWrap
        noFlex
        justify={justify}
        borderRadius={borderRadius}
    >
        <Button
            disabled={loading || cancelDisabled}
            text={cancelLabel}
            {...buttonTheme(cancelTheme)}
            right={16}
            width={widthButtons || 85}
            onClick={() => onCancel()}
        />
        <Button
            disabled={confirmDisabled}
            text={confirmLabel}
            width={widthButtons || 85}
            onClick={() => onConfirm()}
            loading={loading}
            htmlType={htmlType}
        />
    </FooterWrapper>
);

ConfirmFooterButtons.propTypes = {
    onCancel: func,
    cancelDisabled: bool,
    onConfirm: func,
    cancelLabel: string,
    confirmLabel: string,
    confirmDisabled: bool,
    loading: bool,
    justify: string,
    position: string,
    htmlType: string,
    cancelTheme: string,
    widthButtons: number,
    borderRadius: number
};

ConfirmFooterButtons.defaultProps = {
    onCancel: () => {},
    onConfirm: () => {},
    cancelLabel: 'Cancelar',
    confirmLabel: 'Guardar',
    cancelDisabled: false,
    confirmDisabled: false,
    loading: false,
    justify: 'flex-end',
    position: 'absolute',
    cancelTheme: 'secondary'
};

export default ConfirmFooterButtons;
